// src/App.js
import React from 'react';
import 'antd/dist/reset.css';
import './styles/global.css';
import GlobalStyle from './components/GlobalStyle';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import NavBar from './components/NavBar';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashLandingPage from './pages/dashboard/DashLandingPage';
import CreateGamePage from './pages/dashboard/CreateGamePage';
import GamesListPage from './pages/dashboard/GamesListPage';
import PlayerStatsInputPage from './pages/dashboard/PlayerStatsInputPage';
import PlayerInsightsStatsPage from './pages/dashboard/PlayerInsightsStatsPage';
import PlayerStatsComparisonPage from './pages/dashboard/PlayerStatsComparisonPage';
import TeamStatsPage from './pages/dashboard/TeamStatsPage';
import TeamStatsComparisonPage from './pages/dashboard/TeamStatsComparisonPage';
import VideoManagerPage from './pages/dashboard/VideoManagerPage';
import MetadataPage from './pages/MetadataPage';
import UpdateGamePage from './pages/dashboard/UpdateGamePage';

function App() {
  return (
    <Router>
      <GlobalStyle />
      <NavBar />
      <div className="App">
        <Routes>
          
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/glossary" element={<MetadataPage/>} />

          {/* Protected routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <DashLandingPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/create-game" 
            element={
              <ProtectedRoute>
                <CreateGamePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/games" 
            element={
              <ProtectedRoute>
                <GamesListPage />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/dashboard/game/:game_id/update-game"
            element={
              <ProtectedRoute>
                <UpdateGamePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/game/:gameId"
            element={
              <ProtectedRoute>
                <PlayerStatsInputPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/game/:gameId/manage-data/player-stats-input-ingame"
            element={
              <ProtectedRoute>
                <PlayerStatsInputPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard/game/:gameId/manage-data/video"
            element={
              <ProtectedRoute>
                <VideoManagerPage />
              </ProtectedRoute>
            }
          />

          <Route
          path="/dashboard/game/:gameId/player-stats/insights"
          element={
            <ProtectedRoute>
              <PlayerInsightsStatsPage/>
            </ProtectedRoute>
          }
          />

          <Route
          path="/dashboard/game/:gameId/player-stats/comparison"
          element={
            <ProtectedRoute>
              <PlayerStatsComparisonPage/>
            </ProtectedRoute>
          }
          />

          <Route
          path="/dashboard/game/:gameId/team-stats/insights"
          element={
            <ProtectedRoute>
              <TeamStatsPage/>
            </ProtectedRoute>
          }
          />

          <Route
          path="/dashboard/game/:gameId/team-stats/comparison"
          element={
            <ProtectedRoute>
              <TeamStatsComparisonPage/>
            </ProtectedRoute>
          }
          />
        </Routes>
        

      </div>
    </Router>
  );
}

export default App;
